import { Grid } from '@chakra-ui/react';
import { ExperienceJSON } from '@jurnee/common/src/entities/Experience';
import { GridItemImage } from './GridItemImage';

interface Props {
  experiencesImages: ExperienceJSON['experiencesImages'];
}

export function ImagesGrid({ experiencesImages }: Props) {
  return (
    <Grid w="100%" templateColumns="repeat(3, 1fr)" gap="1px" borderRadius={4} overflow="hidden">
      <GridItemImage colSpan={3} path={experiencesImages[0]?.image.path} />
      <GridItemImage path={experiencesImages[1]?.image.path} />
      <GridItemImage path={experiencesImages[2]?.image.path} />
      <GridItemImage path={experiencesImages[3]?.image.path} />
    </Grid>
  );
}